/**
 * A route parameter as the link carried it.
 *
 * The hash router (history v4) decodes nothing a URL reserves (`%40`, `%2B`,
 * `%23` stay as they are), and ant percent-encodes the address in the
 * set-password link where it has to (`#`, `/`, `?`, `%`, spaces, non-ASCII),
 * while the legacy emails put it in raw. Decoding is a no-op for a raw
 * address, and a malformed sequence falls back to the raw value.
 */
export const decodeRouteParam = (raw?: string): string | undefined => {
  if (raw === undefined) return raw;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};
